import React, { Proptypes } from 'react';
import './login.less';
import '../../styles/fonts.less';
import {Link, browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import authActions from './auth_actions';
import ResponsiveHeader from '../header/responsive_header';
import validate from '../util/validate';
import ShowError from '../components/error/show_error';
import MediaQuery from 'react-responsive';
import {toTitleCase,join} from '../util/common';
import CONSTANTS from '../common_constants';
// import {changeLocale, i18nEventsListenerMixin, setupI18NConfiguration, i18n } from "react-i18n-helper";

export default class Login extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      validationError: {},
      error: ''
    }
    this.inputChange = this.inputChange.bind(this);
    this.signInWithEmail = this.signInWithEmail.bind(this);
    this.signinWithFacebook = this.signinWithFacebook.bind(this);

  }

  inputChange(name, event) {
    const stateObj = {};
    stateObj[name] = event.target.value;
    this.setState(stateObj);
  }

  signInWithEmail(e){

    e.preventDefault();
    const {props,state} = this;
    const {email,password} = state;

    let errorMsg = "";
    const validationError = {
      email : !validate.email(email),
      password : !validate.password(password)
    };

    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
      if(validationError[key]) validationFields.push(key);
    });

    if(validationFields.length){
      errorMsg = 'Please enter valid '+join(validationFields,(item, idx) => {
        if(validationFields.length === 1) return "";
        if(idx >0 && idx < validationFields.length-1) return ", ";
        else if(idx === validationFields.length-1) return " and ";
        return "";
      })+'.';
    }

    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }

    props.actions.signinWithEmail(email, password).then(() => {
      this.setState({ error : '' });
      browserHistory.push('/dashboard');
    }, (error) => {
      if(error.message === CONSTANTS.notVerifiedUser){
        this.setState({ error : error.message });
        browserHistory.push('/enter-phoneno');
      }
      this.setState({error: error.error})
    });
  }

  signinWithFacebook(e){
    e.preventDefault();
    const {props} = this;

    props.actions.signinWithFacebook().then((data) => {
      this.setState({ error : '' });
      browserHistory.push('/dashboard');
    }, (error) => {
      if(error.message === CONSTANTS.notVerifiedUser){
        this.setState({ error : error.message });
        browserHistory.push('/enter-phoneno');
      }
      this.setState({error: error})
    });
  }

  render(){
    const self = this;
    const { props, state } = this;
    const {authState, actions} = props;
    const signinState = authState.signin || {};
    const loader = (<div className="loader"></div>);

    let errorMsg = '';
    if(state.error) errorMsg = state.error;
    if(signinState.errorData) errorMsg = signinState.errorData.error || signinState.errorData.message;

    return(
      <div className="login-page">
        <MediaQuery query='(max-width: 767px)'>
          <ResponsiveHeader logoImagePath = "../public/images/landing/logo_white_saffron.png" iconClassName = "user-auth-menu-icon  icon-three-bars" responsiveHeaderClassName = "user-auth-default-header" />
        </MediaQuery>
        <MediaQuery query='(min-width: 768px)'>
          <Link to='/'><div className="awb-logo-wrp"></div></Link>
        </MediaQuery>
        <div className="login-wrapper">
          {state.error && <ShowError errorMessage = {errorMsg} />}
          <div className="login-form-wrap">
            <h1 className="page-header text-align-center">Log In</h1>
            <div className="form-btn-wrap fb-btn-wrap">
              <button
                className = "btn blue"
                onClick = {this.signinWithFacebook}><span className="icon-facebook"></span>
                { signinState.inProgress && signinState.facebookSignin ? loader :'Log in with Facebook' }
              </button>
            </div>
            <form className="login-form">
              <div className="login-or-elm text-align-center">or</div>
              <div className="form-parent-wrp">
                  <span className="icon-email ic-image"></span>
                  <input type="text" placeholder="Email" className="form-input" autoCapitalize="none" name="email" onChange={this.inputChange.bind(self, 'email')}/>
              </div>
              <div className="form-parent-wrp">
                  <span className="icon-pass ic-image"></span>
                  <input placeholder="Password" id="passwordForm" className="form-input" type="password" name="password" onChange={this.inputChange.bind(self, 'password')}/>
              </div>
              <div className="form-btn-wrap login-btn-wrp">
                <button
                  className="btn orange"
                  onClick = {this.signInWithEmail}>
                  {signinState.inProgress && signinState.emailSignin ? loader : 'Log In'}
                </button>
              </div>
              <div className="text-align-center nav-link-wrp">
                <Link to="/forgot-password">
                  <span className = "login-nav-text">
                    <img id="forgotpassword-icon-wrap" src="../../public/icons/forgot password.svg" /><span className = "link">Forgot your password?</span>
                  </span>
                  </Link>
                <div className="text-align-center">
                  <span className = "login-nav-text">Don't have an account?</span>
                  <Link className="nav-link" to="/signup">  Signup</Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}
//connect Login modal and login modal with actions and state
function mapStateToProps(state) {
  return {
    authState : state.app.auth || {}
  }
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(authActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  }
}

Login = connect(mapStateToProps,mapDispatchToProps)(Login);
module.exports = Login;



// WEBPACK FOOTER //
// app/auth/login.jsx